import { Injectable } from '@angular/core';
import {Storage} from '@ionic/storage';
import {ApplicationUserModel} from "../models/application-user.model";

const APPLICATION_USER_KEY = 'vm-app-user';

@Injectable()
export class AuthService {

  constructor(private storage: Storage) {
  }

  async login(email: string): Promise<any> {
    const user = new ApplicationUserModel(email);
    await this.storage.ready();
    return this.storage.set(APPLICATION_USER_KEY, JSON.stringify(user));
  }

  async logout(): Promise<any> {
    await this.storage.ready();
    return this.storage.remove(APPLICATION_USER_KEY);
  }

  async isLoggedIn(): Promise<any> {
    await this.storage.ready();
    const user = await this.getLoggedUser();
    return !!user;
  }

  async getLoggedUser(): Promise<ApplicationUserModel> {
    await this.storage.ready();
    return this.storage.get(APPLICATION_USER_KEY).then( userString => JSON.parse(userString));
  }

}



// WEBPACK FOOTER //
// ./src/services/authService.ts